<div class="label-chip" [ngClass]="{ readonly: readonly }">
  @if (placeholder) {
    <label>{{ placeholder | translate }}</label>
  }
  <mat-chip-listbox #chipList>
    @for (item of value; track item) {
      <mat-chip-option [selectable]="selectable && !readonly" [removable]="removable" (removed)="remove(item)">
        {{ item }}
        @if (showIconForValues?.icon && isExisting(item)) {
          <fa-icon class="extra-icon" [icon]="showIconForValues.icon" />
        }
        @if (removable) {
          <fa-icon matChipRemove icon="times" />
        }
      </mat-chip-option>
    }
    @if (!readonly) {
      <input
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)" />
    }
  </mat-chip-listbox>
</div>
